import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'mage-react-router';
import { Button, Loading } from 'sugar-design';

import Dialog from '@/components/common/Dialog';

import { clearExcelDupApplications } from '@/redux/actions/applications';
import { getI18n } from '@/utils/i18n';

import inputSuccessPng from '@/static/images/inputSuccess.png';

const i18n = getI18n();

class ExcelResult extends React.Component {
  render() {
    const {
      match: {
        params: { orgId, jobId, contractId },
      },
      excelDupApplications,
      enterDup,
      successCount,
      failedCount,
    } = this.props;

    return (
      <div>
        <div className="upload-candidate-result">
          <img width="72" src={inputSuccessPng} />
          <div className="upload-candidate-result__title">
            {enterDup && failedCount !== 0
              ? i18n.t`${successCount}个候选人推荐成功，${failedCount}个候选人因重复推荐失败`
              : i18n.t`批量推荐成功`}
          </div>
          <div className="upload-candidate-result__text" />
          <div className="upload-candidate-result__buttons">
            <Link
              className="btn-wrapper"
              to={`/headhunters/${orgId}/recommend/${jobId}/${contractId}?headhunterType=rpo`}
            >
              <Button className="btn">{i18n.t`继续投递`}</Button>
            </Link>
            <Link className="btn-wrapper" to={`/headhunters/${orgId}/org/jobs`}>
              <Button type="secondary" className="btn">{i18n.t`返回`}</Button>
            </Link>
          </div>
        </div>
        <Dialog
          title={i18n.t`重复添加候选人`}
          isOpen={Boolean(excelDupApplications && excelDupApplications.length)}
          needCancelButton={false}
          disableOutsideClick={true}
          submitText={i18n.t`我知道了`}
          onSubmit={this.props.clearExcelDupApplications}
        >
          {!excelDupApplications || excelDupApplications.length <= 0 ? (
            <Loading message={i18n.t`加载中…`} />
          ) : (
            <table className="dup-applications-table">
              <thead>
                <tr>
                  <th>{i18n.t`姓名`}</th>
                  <th>{i18n.t`电话`}</th>
                  <th>{i18n.t`邮箱`}</th>
                  <th>{i18n.t`年龄`}</th>
                  <th>{i18n.t`性别`}</th>
                  <th>{i18n.t`学历`}</th>
                  <th>{i18n.t`推荐有效性`}</th>
                </tr>
              </thead>
              <tbody>
                {excelDupApplications.map((app) => {
                  return (
                    <tr key={app.id}>
                      <td>{app.name}</td>
                      <td>{app.phone}</td>
                      <td>{app.email}</td>
                      <td>{app.age}</td>
                      <td>{app.gender}</td>
                      <td>{app.academicDegree}</td>
                      <td>{app.merged ? i18n.t`无效推荐` : i18n.t`有效推荐`}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Dialog>
      </div>
    );
  }
}

export default connect(
  ({ applications: { excelDupApplications, enterDup, successCount, failedCount } }) => ({
    excelDupApplications,
    enterDup,
    successCount,
    failedCount,
  }),
  { clearExcelDupApplications }
)(ExcelResult);
